var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("cellsdate",{key:("td-" + _vm.col),tag:"component",attrs:{"col":_vm.col,"entry":_vm.entry,"edit-name":_vm.editName}})}
var staticRenderFns = []

export { render, staticRenderFns }